export default __webpack_public_path__ + "static/media/aboutBottomRight.9435e42f.png";